import BaseEnum from './base-enum';

export default BaseEnum.create({
  values: [
    // ProgressOverviewMode_HALVES (1) reads each learner's latest judgement for
    // each half of the year.
    { value: 1, label: 'Halves' },

    // ProgressOverviewMode_TYPES (2) reads each learner's latest interim and
    // full judgement due in the year.
    { value: 2, label: 'Types' },
  ],
});
